<template>
  <div class="header blogr-container">
    <div class="header__logo">
      <img src="../../../assets/blogr/logo.svg" alt="logo" />
    </div>
    <MobileNav :show="show" />
    <DesktopNav />
      <img
        src="../../../assets/blogr/icon-hamburger.svg"
        v-if="!show"
        @click="toggle"
        alt="open navigation"
        class="hamburger"
      />
      <img
        src="../../../assets/blogr/icon-close.svg"
        v-if="show"
        @click="toggle"
        alt="close navigation"
        class="hamburger"
      />
  </div>
</template>

<script>
import MobileNav from './MobileNav.vue';
import DesktopNav from './DesktopNav.vue';

export default {
  name: 'Header',
  components: { MobileNav, DesktopNav },
  data() {
    return {
      show: false,
    };
  },
  methods: {
    toggle() {
      this.show = !this.show;
    },
  },
};

</script>

<style lang="scss" scoped>
/* breakpoints */
$desktop-media: 74em;

.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
  font-family: var(--ff-alt);

  @media(min-width: $desktop-media) {
    gap: var(--sm-spacer);
  }
}

.hamburger {
  cursor: pointer;
  img {
    transition: all 350ms linear;

    &:hover {
      opacity: 0.7;
    }
  }
}

.hamburger {
  @media(min-width: $desktop-media) {
    display: none;
  }

  @media(max-width: $desktop-media) {
    display: initial;
  }
}
</style>
